<sh-page-layout>
  <sh-header>
    <sh-language-picker position="right"></sh-language-picker>
  </sh-header>

  <div class="reset-password row">
    <img
      src="../../../assets/shipm8-logo.svg"
      alt="{{ 'portal' | translate }}"
    />

    <div class="form-wrapper">
      <form [formGroup]="form">
        <sh-password
          formControlName="newPassword"
          placeholder="{{ 'account.resetPassword.newPassword' | translate }}"
        >
        </sh-password>
        <sh-password
          formControlName="confirmPassword"
          placeholder="{{ 'account.resetPassword.confirmPassword' | translate }}"
        >
        </sh-password>
        <div class="mt-3">
          <sh-message
            *ngIf="form.isSubmitted && form.errors?.['mustMatch'] && form.get('newPassword')?.valid && form.get('confirmPassword')?.valid"
            [content]="'account.resetPassword.error.passwordsDoNotMatch' | translate"
            [severity]="'Error'"
          ></sh-message>
        </div>
        <div class="mt-3">
          <sh-button (click)="resetPassword()"
            >{{ 'account.resetPassword.title' | translate }}</sh-button
          >
          <sh-button link [routerLink]="'/account/login'">
            {{ 'shared.terms.backToLogin' | translate }}
          </sh-button>
        </div>
      </form>
    </div>

    <sh-loading-indicator
      class="text-center"
      *ngIf="isLoading"
    ></sh-loading-indicator>
  </div>
</sh-page-layout>
